import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService, StorageService } from '../../_services/index';
import { DataService, OptionsserviceService, LoansService, OperationsService } from '../../_services/index';

@Component({
  selector: 'app-peertopeer',
  templateUrl: './peertopeer.component.html',
  styleUrls: ['./peertopeer.component.css']
})
export class PeertopeerComponent implements OnInit {
showPicture = false; 
  text = 'Peer  to Peer';
  currentUser: any;
  parentRouteId: any;
  sub: any;
  loan: any;
  creating_contract = false;
  has_workflow = false;
  constructor(private dataService: DataService,
    public route: ActivatedRoute,
    public storageService: StorageService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    public operationsService: OperationsService,
    public router: Router) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }
  ngOnInit() {
    this.getSummary();
  }
  getSummary() {
    this.sub = this.route.params.subscribe(params => {
      this.parentRouteId = +params['id'];
      this.getLoan();
    });

  }
  getLoan() {
    this.loansService.getLoanContract(this.currentUser.token, this.parentRouteId)
      .subscribe(data => {
        this.loan = data.loan;
        this.has_workflow = data.loan.has_workflow;
        this.dataService.onRequestLoadingEndFromBackend.emit();
        if (!this.loan.is_peer_to_peer) {
          this.dataService.onOpenLoanChildModal.emit({ 'location': 'confirm_send_to_market', data: { request_id: this.loan.request_id } });
        }
      });
  }
  openModal(section) {
    this.dataService.onOpenApplicationsModal.emit({ section: section, request_id: this.parentRouteId });
  }
  showLenders(event){
    //this.router.navigate(['./applications/offerletter/' + request_id]);
  }
  openOfferLetter(request_id) {
    this.router.navigate(['./applications/offerletter/' + request_id]);
  }
  doingDisbursement(event) {

  }
}
